var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bg"},[_c('div',{staticClass:"imgBox"},[_c('img',{staticClass:"img_pre",attrs:{"src":_vm.url}}),_vm._v(" "),_c('img',{staticClass:"close_icon cursor",attrs:{"src":require("../../assets/img/common/close.png"),"alt":""},on:{"click":function($event){_vm.$emit('close')}}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8fe8ccc2","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/basic/imgPreview.vue
// module id = null
// module chunks = 